import { Subscription, ReplaySubject, Subject, Observable, fromEvent, of, } from 'rxjs';
import { Component, OnInit, Input, Output, EventEmitter, OnDestroy, ViewChild, AfterViewInit, Inject, ElementRef, Optional, } from '@angular/core';
import { Router, ActivatedRoute, RouterOutlet } from '@angular/router';
import { ApiService } from '../../api.service';
import { ToastrService } from 'ngx-toastr';
declare var $: any;
import { environment } from '../../../environments/environment';
import { FormBuilder, FormGroup, Validators, FormControl, FormArray } from '@angular/forms';
import { datePickerMinDate } from '../../shared/constants';
import { catchError, tap } from 'rxjs/operators';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { NgxFileDropEntry, FileSystemFileEntry } from 'ngx-file-drop';
import { inject } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DatePipe } from '@angular/common';
import { MatTableDataSource } from '@angular/material/table';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import Swal from 'sweetalert2';
import { slideInAnimation } from '../../animations/route-animation';
import { addMonths } from 'date-fns';
import { NavbarComponent } from '../../navbar/navbar.component';

@Component({
	selector: 'app-billing-create',
	templateUrl: './billing-create.component.html',
	styleUrl: './billing-create.component.scss',
	animations: [
		trigger('fadeInOut', [
			state('void', style({
				opacity: 0
			})),
			transition(':enter, :leave', [
				animate(500)
			])
		]),
		slideInAnimation
	]
})
export class BillingCreateComponent implements OnInit {
	breadcrumbList: any[] = [
		{
			path: this.apiService.getHomeURL(),
			name: "Home"
		},
		{
			path: "/app/list-appointment",
			name: "Appointment List"
		}
	];
	uId: any = null;
	billId: any = null;
	caseDetails: any = {};
	invoiceDetails: any = {};
	pageLoading1 = false;
	pageLoading2 = false;
	pageLoading3 = false;
	billingList: any[] = [];
	billingListUSD: any[] = [];
	pagetitle: string = "Create Invoice";
	checkAll = false;
	activeTab: any = 0;
	moduleForm: FormGroup = this.formBuilder.group({
		id: [null],
		invoice_number: [{ value: null, disabled: true }],
		invoice_date: [new Date(), [Validators.required]],
		due_date: [addMonths(new Date(), 1), [Validators.required]],
		total_amount: [{ value: 0, disabled: true }, [Validators.required, Validators.pattern(/^[+-]?([0-9]*[.])?[0-9]+$/)]],
		bill_flag: [false],
		paid_flag: [false],
		is_approved: [false],
		is_invoice_sent: [false],
		auto_invoice_no: [false],
		address: [null, [Validators.required]],
		line_items: this.formBuilder.array([])
	});
	convertLoader = false;
	moduleAccess = "Full";
	minDate = datePickerMinDate;
	formSubmitted = false;
	showLoader = false;
	customError: any = {};
	billCategoryList: any[] = [];
	doctorList: any[] = [];
	followupList: any = [];
	followUpBillsData: any[] = [];
	caseReminder: any = null;

	constructor(private router: Router, private formBuilder: FormBuilder, private apiService: ApiService, private activeRoute: ActivatedRoute, private toastr: ToastrService, @Optional() @Inject(NavbarComponent) public navbar: NavbarComponent) {
		this.apiService.doctorData$.subscribe((doctors: any) => {
			if (doctors) {
				this.getAllDoctors();
			}
		})
	}
	ngOnInit(): void {
		this.activeRoute.params.subscribe(routeParams => {
			this.uId = routeParams["uId"];
			this.billId = routeParams["id"] == undefined ? null : routeParams["id"];
			this.breadcrumbList.push({ path: "/app/appt-details/no/" + this.uId + "/empty", name: "Appointment Details" });
			this.breadcrumbList.push({ path: "/app/case-invoice/" + this.uId, name: "Invoices" });
			if (this.billId) {
				this.breadcrumbList.push({ path: "/app/case-invoice-edit/" + this.uId, name: "Edit" });
				this.getBillDetails();
				this.pagetitle = "Edit Invoice";
			} else {
				this.breadcrumbList.push({ path: "/app/case-invoice-create/" + this.uId, name: "Create" });
			}
			this.getCaseDetails();
			this.getBillCategoryList();
			/* this.getAllDoctors(); */
			this.getFollowup();
			this.getCaseReminders();
		});
	}

	getAndAddNotUsedBillItems() {
		if (this.caseDetails.id) {
			this.pageLoading3 = true;
			this.apiService.getFolloupBillsByCase({ id: this.caseDetails.id }).subscribe({
				next: (data: any) => {
					this.pageLoading3 = false;
					data.data.map((bill: any) => {
						bill.files = bill.files === null ? [] : bill.files;
						bill.gpay_files = bill.gpay_files === null ? [] : bill.gpay_files;
						bill.qrcode_files = bill.qrcode_files === null ? [] : bill.qrcode_files;
						return bill
					});
					this.followUpBillsData = data.data;
					if (!this.billId) {
						let line_items2: any = data.tele_list;
						let len1 = this.followUpBillsData.length;
						let len2 = line_items2.length;
						let itemsAdded = 0;
						for (let i = 0; i < len1; i++) {
							if (!this.followUpBillsData[i].used_in_invoice && this.followUpBillsData[i].is_paid && this.followUpBillsData[i].is_approved) {
								this.addRow();
								let index = this.get_rows.length - 1;
								this.get_rows.controls[index].get("id")?.setValue(null);
								this.get_rows.controls[index].get("cost")?.setValue(this.followUpBillsData[i].amount);
								this.get_rows.controls[index].get("notes")?.setValue(this.followUpBillsData[i].notes);
								this.get_rows.controls[index].get("date")?.setValue(this.apiService.getDateFromDateString(this.followUpBillsData[i].date));
								this.get_rows.controls[index].get("test_id")?.setValue(this.followUpBillsData[i].category);
								this.get_rows.controls[index].get("bill_id")?.setValue(this.followUpBillsData[i].id);
								this.get_rows.controls[index].get("tele_consult_id")?.setValue(null);
								this.get_rows.controls[index].get("tele_consult_dr_id")?.setValue(null);
								this.get_rows.controls[index].get("cost")?.disable();
								this.categoryChanged(index);
								itemsAdded++;
							}
						}
						for (let i = 0; i < len2; i++) {
							if (!line_items2[i].used_in_invoice/*  && line_items2[i].is_paid && line_items2[i].is_approved */) {
								this.addRow();
								let index = this.get_rows.length - 1;
								this.get_rows.controls[index].get("id")?.setValue(null);
								this.get_rows.controls[index].get("cost")?.setValue(line_items2[i].amount);
								this.get_rows.controls[index].get("notes")?.setValue(line_items2[i].notes);
								this.get_rows.controls[index].get("date")?.setValue(this.apiService.getDateFromDateString(line_items2[i].date));
								this.get_rows.controls[index].get("test_id")?.setValue(line_items2[i].category);
								this.get_rows.controls[index].get("bill_id")?.setValue(null);
								this.get_rows.controls[index].get("tele_consult_id")?.setValue(line_items2[i].tele_consult_id);
								this.get_rows.controls[index].get("tele_consult_dr_id")?.setValue(line_items2[i].tele_consult_dr_id);
								this.get_rows.controls[index].get("cost")?.disable();
								this.categoryChanged(index);
								itemsAdded++;
							}
						}
						if (itemsAdded) {
							this.calculateAmount();
							let title = itemsAdded > 1 ? 'Items added' : 'Item added';
							let item = itemsAdded > 1 ? ' bill items which are' : ' bill item which is';
							let text = 'Added ' + '<strong>' + itemsAdded + '</strong>' + item + ' not used previously.';
							Swal.fire({
								title: title,
								html: text,
								icon: "info"
							})
						}
					}
				}, error: (error) => {
					this.pageLoading3 = false;
					this.toastr.error('Something went wrong', 'Error', {
						timeOut: 3000,
						tapToDismiss: true,
						closeButton: true
					});
				}
			})
		}
	}

	getBillDetails() {
		this.pageLoading2 = true;
		this.apiService.getInvoiceDetails({ id: this.billId }).subscribe({
			next: (data: any) => {
				this.pageLoading2 = false;
				this.invoiceDetails = data.data;
				this.f.id.setValue(this.invoiceDetails.id);
				this.f.invoice_number.setValue(this.invoiceDetails.invoice_number);
				this.f.invoice_date.setValue(this.apiService.getDateFromDateString(this.invoiceDetails.invoice_date));
				this.f.due_date.setValue(this.apiService.getDateFromDateString(this.invoiceDetails.due_date));
				this.f.total_amount.setValue(this.invoiceDetails.total_amount);
				this.f.bill_flag.setValue(this.invoiceDetails.bill_flag);
				this.f.paid_flag.setValue(this.invoiceDetails.paid_flag);
				this.f.is_approved.setValue(this.invoiceDetails.is_approved);
				this.f.is_invoice_sent.setValue(this.invoiceDetails.is_invoice_sent);
				this.f.address.setValue(this.invoiceDetails.address);
				/* this.f.auto_invoice_no.setValue(this.invoiceDetails.auto_invoice_no); */
				let line_items: any = this.invoiceDetails.line_items;
				let len = line_items.length;
				for (let i = 0; i < len; i++) {
					this.addRow();
					this.get_rows.controls[i].get("id")?.setValue(line_items[i].id);
					this.get_rows.controls[i].get("cost")?.setValue(line_items[i].cost);
					this.get_rows.controls[i].get("notes")?.setValue(line_items[i].notes);
					this.get_rows.controls[i].get("date")?.setValue(this.apiService.getDateFromDateString(line_items[i].date));
					this.get_rows.controls[i].get("test_id")?.setValue(line_items[i].test);
					this.get_rows.controls[i].get("bill_id")?.setValue(line_items[i].bill);
					this.get_rows.controls[i].get("tele_consult_id")?.setValue(line_items[i].tele_consult);
					this.get_rows.controls[i].get("tele_consult_dr_id")?.setValue(line_items[i].tele_consult_dr);
					if (line_items[i].bill || line_items[i].tele_consult) {
						this.get_rows.controls[i].get("cost")?.disable();
					}
					this.categoryChanged(i);
				}
			}, error: (error) => {
				this.pageLoading2 = false;
				this.toastr.error('Something went wrong', 'Error', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
			}
		});
	}

	get f() { return this.moduleForm.controls; }

	get get_rows() {
		return this.moduleForm.controls['line_items'] as FormArray;
	}

	addRow() {
		const form = this.formBuilder.group({
			id: [null],
			cost: [null, [Validators.required, Validators.pattern(/^[+-]?([0-9]*[.])?[0-9]+$/)]],
			notes: [null, [Validators.required]],
			date: [null, [Validators.required]],
			test_id: [null, [Validators.required]],
			bill_id: [null],
			tele_consult_id: [null],
			tele_consult_dr_id: [null]
		});
		this.get_rows.push(form);
	}

	deleteLoader: any = null;
	deleteRow(index: number) {
		let id = this.get_rows.controls[index].get("id")?.value;
		if (id) {
			Swal.fire({
				title: 'Warning',
				html: 'Are you sure you want to delete record?',
				icon: 'warning',
				showCancelButton: true,
				showConfirmButton: true,
				confirmButtonText: 'Yes, delete it!',
				cancelButtonText: 'Cancel',
				confirmButtonColor: '#dc3545'
			}).then((result) => {
				if (result.value) {
					this.deleteLoader = id;
					this.apiService.deleteInvoiceItem({ id: id }).subscribe({
						next: (res: any) => {
							this.removeRow(index);
							let payload = this.getPayload();
							this.apiService.createUpdateInvoice(payload).subscribe({
								next: (data: any) => {
									this.deleteLoader = null;
									this.toastr.success('Deleted successfully', 'Success', {
										timeOut: 3000,
										tapToDismiss: true,
										closeButton: true
									});
								}, error: (error) => {
									this.deleteLoader = null;
									this.toastr.error("Something went wrong.", 'Error', {
										timeOut: 3000,
										tapToDismiss: true,
										closeButton: true,
									});
								}
							});
						}, error: (error) => {
							this.deleteLoader = null;
							this.toastr.error('Something went wrong', 'Error', {
								timeOut: 3000,
								tapToDismiss: true,
								closeButton: true
							});
						},
					});
				}
			})
		} else {
			this.removeRow(index);
		}
	}

	removeRow(index: number) {
		this.get_rows.at(index).markAsUntouched();
		this.get_rows.at(index).updateValueAndValidity();
		this.get_rows.removeAt(index);
		this.calculateAmount();
		this.moduleForm.markAsDirty();
	}

	showError(field: string) {
		if (this.f[field].invalid && (this.formSubmitted || this.f[field].touched || this.f[field].dirty)) {
			return true;
		}
		return false;
	}

	showError2(index: number, field: string) {
		let f: any = this.get_rows.controls[index].get(field);
		if (f.invalid && (this.formSubmitted || f.touched || f.dirty)) {
			return true;
		}
		return false;
	}

	getBillCategoryList() {
		this.apiService.getAllBillList().subscribe({
			next: (data: any) => {
				this.billCategoryList = data;
			}, error: (error) => {
				this.billCategoryList = [];
			}
		})
	}

	getAllDoctors() {
		/* this.apiService.getDoctorList({}).subscribe({
			next: (data: any) => {
				this.doctorList = data.data.filter((doc) => doc.type_name == "Doctor" || doc.type == 1);
			}, error: (error) => {
				this.doctorList = [];
			},
		}); */
		this.doctorList = this.navbar.filterDoctors().filter((doc) => doc.type_name == "Doctor" || doc.type == 1);
	}

	getCaseDetails() {
		this.pageLoading1 = true;
		this.apiService.getUpdateCaseDetails({ id: this.uId }).subscribe({
			next: (data: any) => {
				this.pageLoading1 = false;
				this.caseDetails = data;
				if (!this.billId) {
					this.f.address.setValue(this.caseDetails.company.address);
				}
				this.getAndAddNotUsedBillItems();
			}, error: (error) => {
				this.pageLoading1 = false;
				this.toastr.error('Something went wrong', 'Error', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
			}
		});
	}

	clearCustomError() {
		Object.keys(this.f).forEach(key => {
			if (this.f[key].hasError('incorrect')) {
				try {
					delete this.f[key].errors?.incorrect;
					this.f[key].updateValueAndValidity();
				} catch (error) { }
			}
		});
		this.customError = {};
	}

	calculateAmount() {
		let totalAmount = 0;
		const len = this.get_rows.controls.length;
		for (let i = 0; i < len; i++) {
			let cost = parseFloat(this.get_rows.controls[i].get("cost")?.value)
			if (!isNaN(cost)) {
				totalAmount += cost;
			}
		}
		totalAmount = Math.round(totalAmount * 100) / 100;
		this.f.total_amount.setValue(totalAmount);
	}

	getPayload() {
		let line_items: any = [];
		const len = this.get_rows.controls.length;
		for (let i = 0; i < len; i++) {
			line_items.push({
				id: this.get_rows.controls[i].get("id")?.value,
				cost: this.get_rows.controls[i].get("cost")?.value,
				notes: this.get_rows.controls[i].get("notes")?.value,
				date: this.apiService.getDateStringFromDate(this.get_rows.controls[i].get("date")?.value),
				test_id: this.get_rows.controls[i].get("test_id")?.value,
				bill_id: this.get_rows.controls[i].get("bill_id")?.value,
				tele_consult_id: this.get_rows.controls[i].get("tele_consult_id")?.value,
				tele_consult_dr_id: this.get_rows.controls[i].get("tele_consult_dr_id")?.value
			});
		}
		if (!line_items.length) {
			this.toastr.info("Please add bill items.", 'Warning', {
				timeOut: 3000,
				tapToDismiss: true,
				closeButton: true
			});
			return;
		}
		let payload: any = {
			"id": this.f.id.value,
			"case_id": this.caseDetails.id,
			"invoice_date": this.apiService.getDateStringFromDate(this.f.invoice_date.value),
			"due_date": this.apiService.getDateStringFromDate(this.f.due_date.value),
			"total_amount": this.f.total_amount.value,
			"paid_flag": this.f.paid_flag.value,
			"bill_flag": this.f.bill_flag.value,
			"is_approved": this.f.is_approved.value,
			"is_invoice_sent": this.f.is_invoice_sent.value,
			"address": this.f.address.value,
			"auto_invoice_no": this.f.auto_invoice_no.value,
			"line_items": line_items
		}
		return payload;
	}

	saveData() {
		this.formSubmitted = true;
		this.clearCustomError();
		if (this.moduleForm.invalid) {
			this.toastr.info("Please check required parameters.", 'Warning', {
				timeOut: 3000,
				tapToDismiss: true,
				closeButton: true
			});
			return;
		}
		let payload: any = this.getPayload();
		this.confirmFinal(payload);
	}

	confirmFinal(payload: any) {
		if (!this.billId) {
			let msgList = this.validateForCaseClosure();
			let str = '<p class="mb-0 text-primary">Is this final billing or partial billing?</p>';
			if (msgList.length) {
				str += '<p class="mb-0">To enable <strong>"Final Billing"</strong> make sure following actions are completed</p>';
				str += "<ol>"
				str += msgList.join("");
				str += "</ol>"
			}
			Swal.fire({
				title: 'Please confirm',
				html: str,
				icon: 'question',
				showConfirmButton: true,
				showCancelButton: true,
				confirmButtonText: 'Final billing',
				cancelButtonText: 'Partial billing',
				confirmButtonColor: '#198754',
				cancelButtonColor: '#0B5ED7',
				customClass: { htmlContainer: 'text-start' },
				/* allowOutsideClick: false,
				allowEscapeKey: false, */
				didOpen: () => {
					if (msgList.length) {
						Swal.getConfirmButton()?.setAttribute('disabled', 'true');
					}
				}
			}).then((result) => {
				if (result.value) {
					this.updateBillingStatus(payload, 2/* , 2 */);
				} else if ((result.dismiss === Swal.DismissReason.cancel)) {
					this.updateBillingStatus(payload, 1/* , this.caseDetails.status */);
				}
			})
		} else {
			this.saveData1(payload);
		}
	}

	updateBillingStatus(payload: any, billing_status: number/* , status_id: number */) {
		this.showLoader = true;
		this.apiService.updateCaseDetails({ id: this.uId, billing_status: billing_status/* , status_id: status_id */ }).subscribe({
			next: (data: any) => {
				this.showLoader = false;
				this.saveData1(payload);
			}, error: (error) => {
				this.showLoader = false;
				this.toastr.error('Something went wrong', 'Error', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
			},
		});
	}

	saveData1(payload: any) {
		this.showLoader = true;
		this.apiService.createUpdateInvoice(payload).subscribe({
			next: (data: any) => {
				this.showLoader = false;
				this.toastr.success("Saved successfully", 'Success', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
				this.gotoList();
			}, error: (error) => {
				this.showLoader = false;
				let errorMsg = "Something went wrong.";
				this.toastr.error(errorMsg, 'Error', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true,
				});
			}
		});
	}

	gotoList() {
		this.router.navigate(['/app/case-invoice', this.uId]);
	}

	validateForCaseClosure() {
		let msgList = this.validateForReadyToBill();
		if (!this.caseDetails.ready_to_bill) {
			msgList.push('<li>Ensure case is marked as <strong>"Ready to bill"<strong></li>')
		}
		return msgList;
	}

	validateForReadyToBill() {
		let msgList: string[] = this.validateForMarkForClosure();
		if (!this.caseDetails.mark_for_closure) {
			msgList.push('<li>Ensure case is marked as <strong>"Marked for closure"</strong></li>');
		}
		let len = this.followUpBillsData.length;
		for (let i = 0; i < len; i++) {
			if (!this.followUpBillsData[i].files.length || !this.followUpBillsData[i].gpay_files.length || !this.followUpBillsData[i].is_paid) {
				msgList.push("<li>Ensure Billing is completed for all followups</li>");
				break;
			}
		}
		return msgList;
	}

	getFollowup() {
		this.apiService.getFollowupList({ id: this.uId }).subscribe({
			next: (data: any) => {
				this.followupList = data.data;
			}, error: (error) => {
				this.followupList = [];
			},
		});
	}

	validateForMarkForClosure() {
		let msgList: string[] = [];
		if (this.caseReminder.crew_details_not_filled) {
			msgList.push("<li>Ensure all crew details are filled</li>");
		}
		if (this.caseReminder.data_not_filled) {
			msgList.push("<li>Ensure key evaluations are filled</li>");
		}
		if (this.caseReminder.files_not_uploaded.length) {
			msgList.push("<li>Upload all missing files under follow-ups</li>");
		}
		for (let i = 0; i < this.followupList.length; i++) {
			if (
				this.followupList[i].follow_up_status?.id == 1
			) {
				msgList.push("<li>Ensure all follow-ups are completed</li>");
				break;
			}
		}
		return msgList;
	}

	getCaseReminders() {
		this.apiService.getCaseReminders(this.uId).subscribe({
			next: (data: any) => {
				this.caseReminder = data;
			}, error: (error) => {
				this.caseReminder = null;
				this.toastr.error(error.error, 'Error', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
			},
		});
	}

	isTeleConsult(index: number) {
		if (this.get_rows.controls[index].get("test_id")?.value == environment.teleconsultCatId) {
			return true;
		}
		return false;
	}

	categoryChanged(index: number) {
		if (this.isTeleConsult(index)) {
			this.get_rows.controls[index].get("tele_consult_dr_id")?.setValidators([Validators.required]);
			this.get_rows.controls[index].get("notes")?.clearValidators();
		} else {
			this.get_rows.controls[index].get("tele_consult_dr_id")?.clearValidators();
			this.get_rows.controls[index].get("notes")?.setValidators([Validators.required]);
		}
		this.get_rows.controls[index].get("tele_consult_dr_id")?.updateValueAndValidity();
		this.get_rows.controls[index].get("notes")?.updateValueAndValidity();
	}

	isAnyTeleConsult() {
		let found = false;
		const len = this.get_rows.controls.length;
		for (let i = 0; i < len; i++) {
			if (this.isTeleConsult(i)) {
				found = true;
			}
		}
		return found;
	}

	getTeleConsultTotal() {
		let totalAmt = 0;
		const len = this.get_rows.controls.length;
		for (let i = 0; i < len; i++) {
			if (this.isTeleConsult(i)) {
				const amt = this.get_rows.controls[i].get("cost")?.value;
				if (!isNaN(amt)) {
					totalAmt += parseFloat(amt);
				}
			}
		}
		totalAmt = Math.round(totalAmt * 100) / 100;
		return totalAmt;
	}

	doctorChanged(index: number) {
		const doc = this.get_rows.controls[index].get("tele_consult_dr_id")?.value;
		if (doc) {
			const len = this.doctorList.length;
			for (let i = 0; i < len; i++) {
				if (this.doctorList[i].id == doc) {
					this.get_rows.controls[index].get("cost")?.setValue(this.doctorList[i].consultation_charges);
				}
			}
		} else {
			this.get_rows.controls[index].get("cost")?.setValue(0);
		}
	}
}
